import { useTranslation } from 'react-i18next';
import { SigninEmail } from '../signin-email';
import { Link, useLocation } from 'react-router-dom';
import { useGetSignupSettings } from '../../hooks/use-auth';
import { LOGIN_COLORS } from '../../constants/login-theme';

export const Signin = () => {
  // Google/SSO sign-in temporarily disabled
  // const { data: loginOption } = useGetLoginOptions();
  const { data: signupSettings } = useGetSignupSettings();

  const { t } = useTranslation();
  const location = useLocation();
  const ssoError = location.state?.ssoError;

  // const passwordGrantAllowed = !!loginOption?.allowedGrantTypes?.includes(GRANT_TYPES.password);
  // // Match signup page: show SSO options whenever providers are configured,
  // // regardless of whether the backend also lists 'social' in allowedGrantTypes.
  // const socialGrantAllowed = !!loginOption?.ssoInfo?.length;
  // const oidcGrantAllowed = !!loginOption?.allowedGrantTypes?.includes(GRANT_TYPES.oidc);
  //
  // const isDivider = passwordGrantAllowed && (socialGrantAllowed || oidcGrantAllowed);

  const showSignupLink =
    signupSettings?.isEmailPasswordSignUpEnabled || signupSettings?.isSSoSignUpEnabled;

  return (
    <div className="flex w-full flex-col gap-8">
      <div className="flex flex-col gap-1.5">
        <h2
          className="text-[2rem] font-bold leading-tight tracking-tight sm:text-[2.125rem]"
          style={{ color: LOGIN_COLORS.textPrimary }}
        >
          {t('WELCOME_BACK')}
        </h2>
        <p className="text-base font-normal leading-6" style={{ color: LOGIN_COLORS.textMuted }}>
          {t('SIGN_IN_TO_ACCOUNT')}
        </p>
      </div>

      {ssoError && (
        <div className="w-full">
          <div className="rounded-lg border border-error bg-error-background p-4">
            <p className="text-xs font-normal text-error-high-emphasis">{ssoError}</p>
          </div>
        </div>
      )}

      <div className="flex w-full flex-col gap-5">
        <SigninEmail />
        {/* {passwordGrantAllowed && <SigninEmail />} */}
        {/* {isDivider && <Divider text={t('OR_CONTINUE_WITH')} />}
        {socialGrantAllowed && loginOption && <SsoSignin loginOption={loginOption} />} */}
      </div>

      {showSignupLink && (
        <div className="flex items-center justify-center gap-2">
          <span className="text-sm leading-5" style={{ color: LOGIN_COLORS.textSecondary }}>
            {t('DONT_HAVE_ACCOUNT')}
          </span>
          <Link
            to="/signup"
            className="text-sm font-semibold leading-5 hover:underline"
            style={{ color: LOGIN_COLORS.primary }}
          >
            {t('SIGN_UP')}
          </Link>
        </div>
      )}
    </div>
  );
};
